/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Art_1_LabelInputs */

const en_svc_agents_art_1_label = /** @type {(inputs: Svc_Agents_Art_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New lead from the website form`)
};

const lv_svc_agents_art_1_label = /** @type {(inputs: Svc_Agents_Art_1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jauns pieteikums no mājaslapas`)
};

/**
* | output |
* | --- |
* | "New lead from the website form" |
*
* @param {Svc_Agents_Art_1_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_art_1_label = /** @type {((inputs?: Svc_Agents_Art_1_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Art_1_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_art_1_label(inputs)
	return en_svc_agents_art_1_label(inputs)
});